<template>
  <v-dialog :value="true" width="90%" @click:outside="$emit('close')">
    <v-btn icon small style="float:right;right:10px;top:10px;z-index:1" @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
    <v-btn icon small style="float:right;right:10px;top:10px;z-index:1" @click="printGraph"><v-icon>mdi-printer</v-icon></v-btn>
    <v-card height="500px">
      <div ref="chart" style="height:490px"/>
    </v-card>
  </v-dialog>
</template>

<script>
import googleCharts from '@/mixins/googleCharts'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'PlanningForecastingGraph',
  mixins: [googleCharts,printHtml],
	props: {
    periods: {type:Array,required:true},
    product: {type:Object, required:true},
    customer: {type:Object, required:false},
    productUnits: {type:String, required:true}
	},
  data() {
    return {
      chart: null
    }
  },
  async mounted() {
    await this.loadGoogleCharts();

    this.showGraph = true;
    window.google.charts.load('current', {'packages':['corechart']});
    window.google.charts.setOnLoadCallback(() => {
      if (this.$refs.chart == undefined)
        return;
      this.chart = new window.google.visualization.ComboChart(this.$refs.chart);

      const data = [['Month','Forecast','Actual']];
      const forecast = this.customer ? this.customer.forecast : this.product.forecast;
      const actuals = this.customer ? this.customer.actuals : this.product.actuals;
      for (const period of this.periods)
        data.push([period.title,
                    forecast.find(forecast => forecast.date === period.date)?.quantity || 0,
                    actuals.find(actual => actual.date === period.date)?.quantity || 0
                    ]);

      const options = {
        chartArea:{height:'75%',width:'90%',left:100},
        title : `${this.product.name} Forecast vs. Actual${this.customer ? ` - ${this.customer.name}` : ``}`,
        titleTextStyle: {fontSize:20},
        legend: {position: 'bottom',textStyle:{fontSize:12}},
        vAxis: {title: this.productUnits, minValue:0, format:'#,###'},
        seriesType: 'bars',
        series: {1: {type: 'line'}}
      };

      this.chart.draw(google.visualization.arrayToDataTable(data), options);
    });

  },
  methods: {
    printGraph() {
      this.printHtml('Forecast',`<style>
                        @page {size:landscape}
                        body {font-family: Roboto, sans-serif; font-size:14px}
                        .title {font-weight:700;font-size:18px;text-align:center;width:100%}
                        .sub-title {text-align:center;margin-bottom:16px,width:100%}
                      </style>
                      <img id="graph"/>`,
                      {id:'graph', src:this.chart.getImageURI()});
    }
  }
}
</script>